import { useIntl, FormattedMessage } from "react-intl";
import {
  Typography,
  TypographyColors,
  TypographyVariants
} from "@certa/catalyst/components/Typography";
import type { FieldAnswer } from "@certa/types";
import { gmtDate } from "@certa/common/utils/time";
import { useWhiteLabellingEnabled } from "@certa/common/toggles/useWhiteLabellingEnabled";
import { DATA_AI, CERTA_AI } from "@certa/common/constants";

type TSubmittedByProps = {
  hasAnswered: boolean;
  answer: Pick<FieldAnswer, "submittedBy" | "submittedAt"> | null;
  isAnsweredByCertaAssist: boolean;
};

// TODO: Add the Avatar instead of name as per the figma design.
export const FieldSubmittedBy = (props: TSubmittedByProps) => {
  const { hasAnswered, answer, isAnsweredByCertaAssist } = props;

  const intl = useIntl();
  const isWhiteLabellingEnabled = useWhiteLabellingEnabled();

  return hasAnswered && answer?.submittedBy ? (
    <FormattedMessage
      id="commonTextInstances.answeredByOn"
      values={{
        name: (
          <Typography
            as="span"
            variant={TypographyVariants.LABEL_SM}
            color={TypographyColors.NEUTRAL_600}
          >
            {isAnsweredByCertaAssist
              ? intl.formatMessage(
                  {
                    id: "recallAI.title",
                    defaultMessage: "{certaAI}"
                  },
                  {
                    certaAI: isWhiteLabellingEnabled ? DATA_AI : CERTA_AI
                  }
                )
              : answer.submittedBy.firstName +
                " " +
                answer.submittedBy.lastName}
          </Typography>
        ),
        haveEmail: !isAnsweredByCertaAssist,
        email: (
          <Typography
            as="span"
            variant={TypographyVariants.LABEL_SM}
            color={TypographyColors.NEUTRAL_800}
          >
            {answer.submittedBy.email}
          </Typography>
        ),
        date: (
          <Typography
            as="span"
            variant={TypographyVariants.LABEL_SM}
            color={TypographyColors.NEUTRAL_600}
          >
            <span aria-label="answered-on">{gmtDate(answer.submittedAt)}</span>
          </Typography>
        )
      }}
    />
  ) : null;
};
